import { useQuery } from 'react-query'
import request from '../../../request'

export const useGetSaasCustomersColumns = () => {
  return useQuery<Array<string>, Error>(
    ['columns', 'saas_customers'],
    () =>
      request({
        url: '/utils/columns/saas_customers',
        method: 'GET',
      }).then((res: any) => res.data),
    { refetchOnWindowFocus: false },
  )
}
